import { useReturnsConfig } from "@narvar/nth-kit-returns-headless";

const useCurrencyConfig = () => {
  const { localeCountry, localeLanguage, includeCurrency } = useReturnsConfig();

  return {
    locale: `${localeLanguage}_${localeCountry}`,
    includeCurrency: !!includeCurrency,
  };
};

export default useCurrencyConfig;
